import request from '@/utils/request'

// 登录方法
export function login (phone, code) {
  const data = {
    phone: phone,
    verificationCode: code
  }
  return request({
    url: '/login/login',
    headers: {
      isToken: false,
      repeatSubmit: false
    },
    method: 'post',
    data: data
  })
}

// 注册方法(废弃)
export function register (data) {
  return request({
    url: '/login/register',
    headers: {
      isToken: false
    },
    method: 'post',
    data: data
  })
}

// 谷歌登录
export function emalogin (googleAccessToken) {
  const data = {
    googleAccessToken: googleAccessToken
  }
  return request({
    url: '/login/emalogin',
    method: 'post',
    data: data
  })
}

// 转谷歌登录
export function gogo () {
  return request({
    url: '/login/gogo',
    method: 'get',
    headers: {}
  })
}

// 获取用户详细信息
export function getInfo () {
  return request({
    url: '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout () {
  return request({
    url: '/login/endout',
    method: 'get'
  })
}

// 获取验证码
export function getCodeImg (data) {
  return request({
    url: '/login/sendCode',
    method: 'post',
    timeout: 20000,
    data: data
  })
}

// 获取用户信息
export function selecustorder (data) {
  return request({
    url: '/cust/selecustorder',
    method: 'post',
    data: data
  })
}

// 修改用户信息
export function updatecust (userdata) {
  const data = userdata
  return request({
    url: '/cust/updatecust',
    method: 'post',
    data: data
  })
}
// 商家是否欠费
export function checkamount () {
  return request({
    url: '/order/checkamount',
    method: 'get'
  })
}
